import styled from 'styled-components';

import {
  BaseButton,
  SignInButton,
  InvertedButton,
} from '../Button/Button.styles';

export const EnvSelectorContainer = styled.div`
  position: absolute;
  width: 340px;
  height: 520px;
  display: flex;
  flex-direction: column;
  padding: 20px;
  border: 1px solid black;
  background-color: white;
  top: 90px;
  right: 40px;
  z-index: 5;

  ${BaseButton},
  ${SignInButton},
  ${InvertedButton} {
    margin-top: auto;
  }
`;

export const EmptyMessage = styled.span`
  font-size: 18px;
  margin: 50px auto;
`;

export const EnvItems = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;